module.exports = __webpack_public_path__ + "static/img/home-s.9df89cd7.png";